<div
    class="fixed inset-0 bg-black w-screen h-screen overflow-hidden select-none group flex items-center justify-center font-sans"
>
    <!-- Loading State -->
    <div *ngIf="isLoading" class="flex flex-col items-center justify-center">
        <svg
            class="animate-spin h-12 w-12 text-[#1a9f81] mb-4"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
        >
            <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
            ></circle>
            <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
        </svg>
        <p class="text-white text-xl animate-pulse">Memuat Iklan...</p>
    </div>

    <!-- Error State -->
    <div *ngIf="error" class="flex flex-col items-center justify-center">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-16 w-16 text-red-500 mb-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
        >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
        </svg>
        <p class="text-red-500 text-xl font-medium">
            Iklan tidak ditemukan atau terjadi kesalahan.
        </p>
    </div>

    <!-- Display Ads -->
    <ng-container *ngIf="!isLoading && !error && adData">
        <!-- Top Progress Bars -->
        <div
            class="absolute top-0 left-0 right-0 z-20 flex gap-2 p-4 bg-gradient-to-b from-black/70 to-transparent"
            *ngIf="adData.media?.length > 1"
        >
            <div
                *ngFor="let m of adData.media; let i = index"
                class="h-2 flex-1 bg-white/30 rounded-full overflow-hidden shadow-sm"
            >
                <div
                    class="h-full bg-white transition-all duration-75 ease-linear rounded-full"
                    [style.width.%]="
                        i < currentIndex
                            ? 100
                            : i === currentIndex
                              ? progress
                              : 0
                    "
                ></div>
            </div>
        </div>

        <!-- Media Container -->
        <ng-container *ngIf="adData.media && adData.media.length > 0; else noMedia">
            <ng-container *ngFor="let m of adData.media; let i = index">
                <div *ngIf="i === currentIndex" class="absolute inset-0 flex items-center justify-center bg-black z-0">
                    <img *ngIf="m.type === 'image' || !m.mime_type?.startsWith('video')" 
                         [src]="getMediaUrl(m)" 
                         class="w-full h-full object-contain drop-shadow-2xl" />
                    <video #vid *ngIf="m.type === 'video' || m.mime_type?.startsWith('video')" 
                           [src]="getMediaUrl(m)" 
                           (loadeddata)="vid.play()"
                           (canplay)="vid.play()"
                           class="w-full h-full object-contain drop-shadow-2xl"
                           [autoplay]="true" [loop]="true" [muted]="false" playsinline></video>
                </div>
            </ng-container>
        </ng-container>
        <ng-template #noMedia>
            <div class="flex flex-col items-center justify-center text-white/50 z-0 h-full w-full absolute inset-0">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-24 w-24 mb-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                <p class="text-3xl font-light tracking-wider">Tidak ada media untuk ditampilkan</p>
            </div>
        </ng-template>

        <!-- Navigation Arrows (appear on hover/interaction) -->
        <ng-container *ngIf="adData.media?.length > 1">
            <button
                (click)="prevSlide()"
                class="absolute left-6 top-1/2 -translate-y-1/2 z-30 bg-black/40 hover:bg-black/80 text-white p-4 rounded-full backdrop-blur-md transition-all duration-300 opacity-0 group-hover:opacity-100 focus:opacity-100 cursor-pointer shadow-2xl border border-white/10"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-10 w-10"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2.5"
                        d="M15 19l-7-7 7-7"
                    />
                </svg>
            </button>
            <button
                (click)="nextSlide()"
                class="absolute right-6 top-1/2 -translate-y-1/2 z-30 bg-black/40 hover:bg-black/80 text-white p-4 rounded-full backdrop-blur-md transition-all duration-300 opacity-0 group-hover:opacity-100 focus:opacity-100 cursor-pointer shadow-2xl border border-white/10"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-10 w-10"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2.5"
                        d="M9 5l7 7-7 7"
                    />
                </svg>
            </button>
        </ng-container>

        <!-- Optional Bottom Info -->
        <div
            class="absolute bottom-0 left-0 right-0 p-10 bg-gradient-to-t from-black/90 via-black/50 to-transparent z-20 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
        >
            <h1 class="text-white text-4xl font-bold tracking-tight shadow-sm">
                {{ adData.title }}
            </h1>
            <p
                class="text-white/80 text-xl mt-3 font-light max-w-4xl leading-relaxed"
                *ngIf="adData.description"
            >
                {{ adData.description }}
            </p>
        </div>
    </ng-container>
</div>
